// @flow weak

import {combineReducers} from 'redux';
import _ from 'lodash/fp';
import {
  GET_REQUEST,
  GET_SUCCESS,
  GET_FAILURE,
  FILTER,
  SORT,
} from '../actions/orderList';
import {totalPrice} from '../helpers/priceHelpers';

const isFetching = (state = false, action) => {
  switch (action.type) {
    case GET_REQUEST:
      return true;
    case GET_SUCCESS:
    case GET_FAILURE:
      return false;
    default:
      return state;
  }
};

const error = (state = null, action) => {
  switch (action.type) {
    case GET_SUCCESS:
      return null;
    case GET_FAILURE:
      return action.error;
    default:
      return state;
  }
};

const archived = (state = false, action) => {
  switch (action.type) {
    case FILTER:
      return action.archived;
    default:
      return state;
  }
};

const query = (state = null, action) => {
  switch (action.type) {
    case FILTER:
      return action.query;
    default:
      return state;
  }
};

const projectId = (state = null, action) => {
  switch (action.type) {
    case FILTER:
      return action.projectId;
    default:
      return state;
  }
};

const salesUserId = (state = null, action) => {
  switch (action.type) {
    case FILTER:
      return action.salesUserId;
    default:
      return state;
  }
};

const orderState = (state = null, action) => {
  switch (action.type) {
    case FILTER:
      return action.orderState;
    default:
      return state;
  }
};

const filter = combineReducers({
  archived,
  orderState,
  salesUserId,
  query,
  projectId,
});

const orders = (state = [], action) => {
  switch (action.type) {
    case GET_SUCCESS:
      return _.flow(
        _.filter(o => o.apartment.project.archived === null),
        _.map(o => ({...o, totalPrice: totalPrice(o)})),
      )(action.orders);
    default:
      return state;
  }
};

const isArchived =
  _.filter(o => _.isString(o.archived));

const notArchived =
  _.filter({archived: null});

const mapProjects =
  _.flow(
    _.map('apartment.project'),
    notArchived,
    _.uniqBy('id')
  );

const projects = (state = [], action) => {
  switch (action.type) {
    case GET_SUCCESS:
      return mapProjects(action.orders);
    default:
      return state;
  }
};

const filterProjects = projectId =>
  _.filter({apartment: {projectId}});

const filterSalesUsers = salesUserId =>
  _.filter({salesUserId});

const filterOrderStates = state =>
  _.filter({state});

const filteredOrders = (state = {}, action) => {
  switch (action.type) {
    case GET_SUCCESS:
    case FILTER:
    case SORT:
      return _.flow(
        state.filter.archived
          ? isArchived
          : notArchived,
        state.filter.orderState
          ? filterOrderStates(state.filter.orderState - 1)
          : _.identity,
        state.filter.projectId
          ? filterProjects(state.filter.projectId)
          : _.identity,
        state.filter.salesUserId
          ? filterSalesUsers(state.filter.salesUserId)
          : _.identity,
        state.sorter,
      )(state.orders);
    default:
      return state.filteredOrders;
  }
};

const salesUsers = (state = [], action) => {
  switch (action.type) {
    case GET_SUCCESS:
      return action.salesUsers;
    default:
      return state;
  }
};

const sorter = (state = _.identity, action) => {
  switch (action.type) {
    case SORT:
      return action.sorter;
    default:
      return state;
  }
};

const reducers = combineReducers({
  salesUsers,
  filteredOrders: (s = []) => s,
  isFetching,
  error,
  filter,
  orders,
  projects,
  sorter,
});

const orderList = (state, action) => {
  const newState = reducers(state, action);
  return {
    ...newState,
    filteredOrders: filteredOrders(newState, action),
  };
};

export default orderList;



// WEBPACK FOOTER //
// ./src/reducers/orderList.js